import { type ClassValue, clsx } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}

export function assetUrl(path: string) {
  if (/^https?:/.test(path)) return path
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return normalizedPath
}
